import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("label", null, "대표 이미지", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("input", {
      type: "file",
      class: "form-control-file",
      ref: "thumbnailFile",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previewImage && _ctx.previewImage(...args))),
      accept: _ctx.acceptType
    }, null, 40, ["accept"]),
    (_ctx.previewImg.endsWith('pdf'))
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          class: "btn btn-btn-primary",
          href: `${_ctx.setPreviewImg}`,
          target: "_blank"
        }, [
          _createVNode("object", {
            class: "",
            type: "application/pdf",
            data: `${_ctx.setPreviewImg}#toolbar=1`
          }, null, 8, ["data"])
        ], 8, ["href"]))
      : (_openBlock(), _createBlock("a", {
          key: 1,
          class: "btn btn-btn-primary",
          href: `${_ctx.setPreviewImg}?w=800`,
          target: "_blank"
        }, [
          _createVNode("img", {
            class: "preview",
            height: "200",
            src: _ctx.previewImg
          }, null, 8, ["src"])
        ], 8, ["href"]))
  ], 64))
}